module.exports = __webpack_public_path__ + "static/media/Group 4367.2c1135ea.svg";